// extracted by mini-css-extract-plugin
export default {"sectionContainer":"schools_sectionContainer__gb2uG","heading":"schools_heading__S2aQj","sectionPart":"schools_sectionPart__iIx5l"};